const prizes = [
  {
    id: 1,
    title: 'Lotte Hotel Stay Voucher',
    description: '롯데호텔 서울 숙박권으로 프리미엄을 경험하세요. 그랜드 디럭스룸과 르살롱 라운지를 이용할 수 있습니다.',
    image: 'https://static.readdy.ai/image/4185a7ed610e75d736f4dab717ebea2f/fc72b2afec9a7a293443bf2f487eb8ec.webp',
    icon: 'ri-hotel-line'
  },
  {
    id: 2,
    title: 'Instax WIDE EVO',
    description: '소중한 순간을 즉석에서 인화해보세요. 디지털과 아날로그 감성을 담은 프리미엄 하이브리드 카메라로 추억을 남겨보세요.',
    image: 'https://static.readdy.ai/image/4185a7ed610e75d736f4dab717ebea2f/d5dd4c37edbcac9ac63ec8295041f62c.jpeg',
    icon: 'ri-camera-line'
  },
  {
    id: 3,
    title: 'Delica Hans Gift Card',
    description: '고급스러운 미식의 세계를 특별한 선물로 경험해보세요.',
    image: 'https://static.readdy.ai/image/4185a7ed610e75d736f4dab717ebea2f/c97e8d5d6759951bac9f7b64aca6de79.jpeg',
    icon: 'ri-gift-line'
  }
];

export default function Prizes() {
  return (
    <section className="py-32 px-6 bg-neutral-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <div className="inline-block w-16 h-px bg-neutral-300 mb-8"></div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl mb-8 font-light tracking-tight text-neutral-900" style={{ fontFamily: 'Playfair Display, serif' }}>
            Premium Prizes
          </h2>
          <p className="text-lg text-neutral-600 font-light max-w-2xl mx-auto">
            세 가지 특별한 프리미엄 경품을 만나보세요.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {prizes.map((prize, index) => (
            <div 
              key={prize.id}
              className="group bg-white overflow-hidden transition-all duration-500 hover:shadow-2xl cursor-pointer"
              style={{ 
                animation: `fadeInUp 0.8s ease-out ${index * 0.2}s both`
              }}
            >
              <div className="relative h-80 overflow-hidden">
                <img 
                  src={prize.image}
                  alt={prize.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-500"></div>
              </div>
              
              <div className="p-10">
                <div className="flex items-center justify-center w-14 h-14 bg-neutral-100 mb-6 transition-colors duration-300 group-hover:bg-neutral-900">
                  <i className={`${prize.icon} text-2xl text-neutral-900 transition-colors duration-300 group-hover:text-white`}></i>
                </div>
                <h3 className="text-2xl mb-4 font-light tracking-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
                  {prize.title}
                </h3>
                <p className="text-neutral-600 leading-relaxed font-light">
                  {prize.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
}
